import React, { Component } from "react";
import PropTypes from "prop-types";
import { View, Text, StyleSheet, Platform, Dimensions } from "react-native";
import Theme from "../../theme";
import Select, { components } from "react-select";

const { width } = Dimensions.get("window");
const isMobile = width <= 550;

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  getSelectedOption(displayOptions, value, defaultValue) {
    const { showThumbnailInLabel = false } = this.props;
    let selectedValue = value ? value : defaultValue;
    let optionForValue = displayOptions.find(o => o.value == selectedValue);
    if (optionForValue && showThumbnailInLabel) {
      optionForValue.label = optionForValue.thumbnail ? optionForValue.thumbnail : optionForValue.display;
    }
    return optionForValue ? optionForValue : null;
  }

  allOptions = () => {
    const { displayKey, valueKey } = this.props;
    return this.props.options.map(singleOption => {
      return {
        value: singleOption[valueKey],
        display: singleOption[displayKey],
        label:  singleOption[displayKey],
        ...singleOption,
      }
    });
  };

  shouldShowLabel = () => {
    const {
      input: { value },
      showLabel = true
    } = this.props;
    if (!showLabel) {
      return false;
    }

    if (Platform.OS == "web" && isMobile == false) {
      return true;
    } else {
      return !!value && showLabel;
    }
  };

  dropDownStyles = () => {
    const { useDarkTheme, useTransparentTheme = false, controlStyle={}, useTransparentDarkTheme, optionTextStyle={}, controlTextStyle = {}, menuListStyle = {}, imageKey = false, useBoldControlText = false, controlFontSize = 16, controlFontWeight = 'normal', dropDownHeight = '38', optionContainer = null } = this.props;
    const themeStyles = useTransparentDarkTheme ? transparentThemeDarkStyles : useDarkTheme ? darkThemeStyles : useTransparentTheme ? transparentThemeStyles : lightThemeStyles;
    return {
      control: styles => ({
        ...styles,
        ...themeStyles.control,
        position: "relative",
        height: dropDownHeight,
        ...controlStyle,
      }),
      menu: styles => ({
        ...styles,
        ...menuListStyle,
      }),
      menuList: styles => ({
        ...styles,
        ...themeStyles.control,
        ...optionContainer,
      }),
      singleValue: (styles, { isDisabled }) => {
        return {
          ...styles,
          ...themeStyles.control,
          color: isDisabled ? Theme.GREY_DARK_MEDIUM : themeStyles.control.color,
          fontSize: controlFontSize,
          fontWeight: controlFontWeight,
          ...controlTextStyle,
        };
      },
      option: (styles, { isFocused, isSelected }) => {
        return {
          ...styles,
          display: 'flex',
          backgroundColor: isFocused
            ? themeStyles.option.backgroundColor
            : null,
          color: isFocused
            ? Theme.CHARCOAL
            : isSelected
              ? Theme.PRIMARY
              : optionTextStyle ? optionTextStyle.color : themeStyles.option.color,
          ":hover": {
            ...styles[":hover"],
            cursor: "pointer",
            color: Theme.CHARCOAL,
            backgroundColor: themeStyles.option.backgroundColor,
          }
        };
      }
    };
  };

  DropdownIndicator = (props, showError, isRequired, placeholder, error, hideIndicatorSeparator) => {
    const { isDisabled } = props;
    const hideSeparator = hideIndicatorSeparator ? hideIndicatorSeparator : false;
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {showError && (
          <span className="errorContainer">
            <p className="errorMessage">{error}</p>
          </span>
        )}
        {isRequired && !showError && !isDisabled && (
          <span className="noErrorContainer">
            <p className="asterisk">*</p>
          </span>
        )}
        {hideSeparator === false &&
          <components.IndicatorSeparator {...props} />}
        <components.DropdownIndicator {...props} />
      </div>
    );
  };
  Option = (props, imageKey) => {
    return (<components.Option {...props}>
      {props.data[imageKey] ? props.data[imageKey] : null}
      <div style={{ paddingLeft: 10, paddingTop: imageKey ? 10 : 0 }}>
        {props.label}
      </div>
    </components.Option>)
  }

  render() {
    const {
      input: { onChange, value = "" },
      defaultValue = "",
      placeholder,
      isRequired = true,
      onSelect,
      disabled,
      isSearchable,
      webAbsolute = false,
      meta: { touched, error, submitFailed } = {},
      imageKey = null,
      mainDropdownContainerStyle = {},
      menuPlacement = 'bottom',
      hideIndicatorSeparator,
    } = this.props;
    const allOptions = this.allOptions();
    const selectedOption = this.getSelectedOption(
      allOptions,
      value,
      defaultValue
    );
    const properStyle = this.dropDownStyles();
    const showError = (submitFailed && !!error) || (touched && !!error);
    return (
      <View style={[styles.container, mainDropdownContainerStyle]}>
        {this.shouldShowLabel() && (
          <Text style={styles.labelText}>{placeholder}</Text>
        )}
        <Select
          value={selectedOption}
          className="controlOption"
          classNamePrefix={webAbsolute ? "absolute-select" : "select"}
          defaultValue={selectedOption}
          placeholder={placeholder}
          onChange={option => {
            if (onSelect) {
              onSelect(option.value);
            }
            onChange(option.value);
          }}
          isSearchable={isSearchable}
          options={allOptions}
          styles={properStyle}
          isDisabled={disabled}
          menuPlacement={menuPlacement}
          components={{
            IndicatorSeparator: () => null,
            DropdownIndicator: props =>
              this.DropdownIndicator(
                props,
                showError,
                isRequired,
                placeholder,
                error,
                hideIndicatorSeparator
              ),
            Option: props =>
              this.Option(
                props,
                imageKey
              )
          }}
        />
      </View>
    );
  }
}

Dropdown.propTypes = {
  options: PropTypes.array.isRequired,
  valueKey: PropTypes.string.isRequired,
  defaultIndex: PropTypes.number,
  defaultValue: PropTypes.string
};

const styles = StyleSheet.create({
  labelText: {
    color: Theme.GREY
  },
  container: {
    // marginVertical: 3,
  },
});

const lightThemeStyles = {
  control: {
    color: Theme.CHARCOAL,
    borderColor: Theme.GREY_LIGHT
  },
  option: {
    backgroundColor: Theme.GREY,
    color: Theme.CHARCOAL
  }
};

const darkThemeStyles = {
  control: {
    color: Theme.White,
    backgroundColor: Theme.GREY_DARK,
    borderColor: Theme.GREY_DARK,
  },
  option: {
    backgroundColor: Theme.GREY,
    color: Theme.GREY_LIGHT
  }
};

const transparentThemeStyles = {
  control: {
    color: Theme.CHARCOAL,
    backgroundColor: 'transparent',
    borderColor: 'transparent'
  },
  option: {
    backgroundColor: Theme.GREY,
    color: Theme.CHARCOAL
  }
};

const transparentThemeDarkStyles = {
  control: {
    color: Theme.WHITE,
    backgroundColor: 'transparent',
    borderColor: 'transparent'
  },
  option: {
    backgroundColor: Theme.GREY,
    color: Theme.GREY_LIGHT
  }
};

export default Dropdown;
